// store/todoList.js
import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  items: {},
  counts: {
    completed: 0,
    notCompleted: 0,
    notCompletedForms: 0,
  },
  pending: false,
  error: null,
};

// Load To-Do list
const getToDoList = createAsyncThunk('todoList/getToDoList', async (params) => {
  return application.call(API.ORGANIZATION.GET_TO_DO_LIST, params);
});

function onGetToDoList(state, action) {
  const payload = action.payload || {};

  // From your log:
  // payload = {
  //   result: { ...items... },
  //   counts: { completed: 6, notCompleted: 2 }
  // }

  const rawItems = payload.result || {};
  const rawCounts = payload.counts || {};

  const completed = Number(rawCounts.completed !== undefined && rawCounts.completed !== null ? rawCounts.completed : 0);

  const notCompleted = Number(
    rawCounts.notCompleted !== undefined && rawCounts.notCompleted !== null ? rawCounts.notCompleted : 0
  );

  const notCompletedForms = Number(
    rawCounts.notCompletedForms !== undefined && rawCounts.notCompletedForms !== null ? rawCounts.notCompletedForms : 0
  );

  state.items = rawItems;
  state.counts = {
    completed,
    notCompleted,
    notCompletedForms,
  };
  state.pending = false;
  state.error = null;
}

// Toggle To-Do status (complete/incomplete) by request id
const toggleToDoStatus = createAsyncThunk('todoList/toggleToDoStatus', async (params) => {
  return application.call(API.ORGANIZATION.TOGGLE_TO_DO_STATUS, params);
});

// Optional optimistic update: flip status locally for the target item
function onToggleToDoStatusFulfilled(state, action) {
  const arg = action.meta?.arg || {};
  const targetId = arg.todoId || arg.requestId || arg.id;

  if (!targetId) {
    return;
  }

  const items = state.items || {};
  const keys = Object.keys(items);

  keys.forEach((key) => {
    const item = items[key];
    if (item && item.id === targetId) {
      const currentStatus = item.status;
      let nextStatus = currentStatus;

      if (currentStatus === 'Completed') {
        nextStatus = 'Not Started';
      } else if (currentStatus === 'Not Started') {
        nextStatus = 'Completed';
      }

      items[key] = {
        ...item,
        status: nextStatus,
      };
    }
  });
}

export const actions = {
  getToDoList,
  toggleToDoStatus,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    // Get list
    .addCase(getToDoList.pending, (state) => {
      state.pending = true;
      state.error = null;
    })
    .addCase(getToDoList.fulfilled, onGetToDoList)
    .addCase(getToDoList.rejected, (state, action) => {
      state.pending = false;
      state.error = action.error?.message || 'Failed to load To-Do list';
    })

    // Toggle status
    .addCase(toggleToDoStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(toggleToDoStatus.fulfilled, onToggleToDoStatusFulfilled)
    .addCase(toggleToDoStatus.rejected, (state, action) => {
      state.error = action.error?.message || 'Failed to toggle To-Do status';
    });
});
